<template lang="pug">
	v-dialog(v-model="dialogEditDevice" content-class="haq-dialog" max-width="792px" scrollable @click:outside="toggleEditDevice")
		v-card.haq-dialog-card
			v-card-title
				span(class="text-h5") Device Info
				v-spacer
				v-icon.close(text @click="toggleEditDevice") mdi-close
			v-card-text
				v-row
					v-col(cols="12" md="6")
						HaqTextField(v-model="deviceDetails.deviceName" label="Device Name")
					v-col(cols="12" md="6")
						HaqTextField(v-model="deviceDetails.name" label="Model Name" disabled)
					v-col(cols="12" md="6")
						HaqTextField(v-model="deviceDetails.serialNum" label="Serial Number" disabled)
					v-col.d-none.d-md-flex(cols="12" md="6")
					v-col(cols="12" md="6")
						HaqTextField(v-model="deviceDetails.rssi" label="RSSI" disabled)
					v-col(cols="12" md="6")
						//-HaqSelect(v-model="deviceZone" :items="zones" item-text="name" item-value="objectId" label="Zone" hide-details)
						HaqTextField(v-model="deviceDetails.zone" disabled item-text="name" item-value="objectId" label="Zone" hide-details)
					v-col(cols="12" md="6")
						HaqTextField(v-model="deviceDetails.connected" label="Connected" disabled)
					v-col(cols="12" md="6")
						HaqTextField(v-model="formattedLastHeardFrom" label="Last Heard From" disabled)
					v-col(cols="12" md="6" v-if="deviceDetails.metadata?.firmwareVersion")
						HaqTextField(v-model="deviceDetails.metadata.firmwareVersion" label="Firmware Version" disabled)
					v-col(cols="12" md="6" v-if="deviceDetails.deviceId")
						HaqTextField(v-model="deviceDetails.deviceId" label="Device ID" disabled)
					template(v-if="hasMetadata")
						v-col(cols="12" md="6" v-for="field in metadataFields" :key="field.key")
							HaqTextField(
								v-model="deviceDetails.metadata[field.key]"
								:label="field.label"
								disabled
							)

				.edge-section.mt-6(v-if="edgeAttach.isHalo")
					h3.text-subtitle-1.mb-2 Virtual Edge (LAN)
					p.text-caption.mb-6 Attach an Edge HTTP device so cloud can reach this Halo on the LAN.
					v-alert(v-if="edgeError" type="error" dense text class="mb-4") {{ edgeError }}
					template(v-if="edgeAttach.attached")
						v-row
							v-col(cols="12" md="6")
								HaqTextField(
									:value="edgeAttach.edgeDeviceName || edgeAttach.edgeDeviceKey"
									label="Attached Edge Device"
									disabled
								)
							v-col(cols="12" md="6")
								HaqTextField(
									:value="edgeAttach.installationName || edgeAttach.installationId"
									label="Installation"
									disabled
								)
							v-col(cols="12" md="6")
								HaqTextField(
									:value="edgeAttach.status || '—'"
									label="Edge Status"
									disabled
								)
							v-col.d-flex.align-end(cols="12" md="6")
								v-btn.haq-btn.haq-btn-secondary.mb-1(
									:loading="edgeBusy"
									@click="detachEdge"
								) Detach
					template(v-else)
						v-row
							v-col(cols="12" md="6")
								HaqSelect(
									v-model="selectedEdgeDeviceId"
									:items="edgeCandidateItems"
									item-text="label"
									item-value="edgeDeviceId"
									label="Edge HTTP Device"
									:loading="edgeLoading"
									clearable
									hide-details
								)
							v-col.d-flex.align-end(cols="12" md="6")
								v-btn.haq-btn.haq-btn-primary.mb-1(
									:disabled="!selectedEdgeDeviceId"
									:loading="edgeBusy"
									@click="attachEdge"
								) Attach
			v-card-actions
				v-spacer
				v-btn.haq-btn.haq-btn-secondary(@click="toggleEditDevice") Cancel
				v-btn.haq-btn.haq-btn-primary(@click="saveDevice") Save

</template>
<script>
import Navbar from '@/components/Navbar.vue'
import HaqSelect from '@/components/form/HaqSelect.vue'
import HaqTextField from '@/components/form/HaqTextField.vue'
import {HTTPClient} from '../../assets/js/http'
let client = new HTTPClient();

export default {
    name: 'DeviceModal',
    components: {
        Navbar,
        HaqSelect,
        HaqTextField,
    },
	props: {
		action: String,
		device: Object,
	},
    data() {
        return {
            siteId: this.$route.query.siteId,
            dialogEditDevice: this.action == 'edit' ? true : false,
			deviceDetails: {...this.device},
			deviceZone: null,
			zones: [],
			edgeAttach: { isHalo: false, attached: false },
			edgeCandidates: [],
			selectedEdgeDeviceId: null,
			edgeLoading: false,
			edgeBusy: false,
			edgeError: null
        }
    },
    computed: {
        hasMetadata() {
            return this.deviceDetails?.metadata && 
                Object.keys(this.deviceDetails.metadata).length > 0;
        },
        metadataFields() {
            if (!this.deviceDetails?.metadata) return [];
            
            return Object.entries(this.deviceDetails.metadata)
                .filter(([key, value]) => value !== null && value !== undefined && key !== 'firmwareVersion')
                .map(([key, _]) => ({
                    key,
                    label: this.formatLabel(key)
                }));
        },
        metadataChunks() {
            // Split metadata fields into chunks of 2 for displaying in columns
            const chunks = [];
            for (let i = 0; i < this.metadataFields.length; i += 2) {
                chunks.push(this.metadataFields.slice(i, i + 2));
            }
            return chunks;
        },
        /**
         * Format last heard from timestamp with date and timezone abbreviation
         * @returns {string} Formatted date and time with timezone abbreviation
         */
        formattedLastHeardFrom() {
            if (!this.deviceDetails?.lastHeardFrom) return '';
            const date = new Date(this.deviceDetails.lastHeardFrom);
            const dateStr = date.toLocaleDateString();
            const timeStr = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
            const timezoneStr = date.toLocaleTimeString('en-US', { timeZoneName: 'short' }).split(' ').pop();
            return `${dateStr} ${timeStr} ${timezoneStr}`;
        },
		/**
		 * Select items for Edge HTTP attach picker.
		 * @returns {{ edgeDeviceId: string, label: string }[]}
		 */
		edgeCandidateItems() {
			return (this.edgeCandidates || []).map(c => ({
				edgeDeviceId: c.edgeDeviceId,
				label: `${c.name || c.key}${c.host ? ' @ ' + c.host : ''}${c.installationName ? ' (' + c.installationName + ')' : ''}`
			}));
		}
    },
    methods: {
        formatLabel(key) {
            // Convert camelCase or snake_case to Title Case
            return key
                .replace(/([A-Z])/g, ' $1') // Insert space before capital letters
                .replace(/_/g, ' ') // Replace underscores with spaces
                .replace(/^\w/, c => c.toUpperCase()) // Capitalize first letter
                .trim();
        },
        toggleEditDevice() {
            this.dialogEditDevice = false
			this.$emit('closeDeviceModal')
        },
        async saveDevice() {
            try {
                await client.robustPost(`/api/devices/${this.device.objectId}`, {
					deviceName: this.deviceDetails.deviceName,
				})
				this.toggleEditDevice();
			} catch(e) {
				console.log(e)
			}
        },
		async getZones() {
			try {
				let result = await client.robustQuery(`/api/zones?siteId=${this.siteId}`);
				this.zones = result.results;
				this.deviceZone = this.zones.find(x => x.objectId === this.device.zoneId)?.objectId;
			} catch (error) {
				console.error(error);
			}
		},
		/**
		 * Load edge attach state and candidate HTTP devices.
		 */
		async loadEdgeAttach() {
			if (!this.device?.objectId) return;
			this.edgeLoading = true;
			this.edgeError = null;
			try {
				const attachRes = await client.robustQuery(`/api/devices/${this.device.objectId}/edge`);
				this.edgeAttach = attachRes.results || { isHalo: false, attached: false };
				if (this.edgeAttach.isHalo && !this.edgeAttach.attached) {
					const candRes = await client.robustQuery(`/api/devices/${this.device.objectId}/edge-candidates`);
					this.edgeCandidates = candRes.results || [];
				} else {
					this.edgeCandidates = [];
				}
			} catch (error) {
				console.error(error);
				this.edgeError = error.message || 'Failed to load edge attach state';
			} finally {
				this.edgeLoading = false;
			}
		},
		/**
		 * Attach selected Edge HTTP device to this Halo Device.
		 */
		async attachEdge() {
			if (!this.selectedEdgeDeviceId) return;
			this.edgeBusy = true;
			this.edgeError = null;
			try {
				const res = await client.robustPost(`/api/devices/${this.device.objectId}/edge-attach`, {
					edgeDeviceId: this.selectedEdgeDeviceId
				});
				this.edgeAttach = res.results || this.edgeAttach;
				this.selectedEdgeDeviceId = null;
				this.edgeCandidates = [];
			} catch (error) {
				console.error(error);
				this.edgeError = error.message || 'Attach failed';
			} finally {
				this.edgeBusy = false;
			}
		},
		/**
		 * Detach Edge HTTP device from this Device.
		 */
		async detachEdge() {
			this.edgeBusy = true;
			this.edgeError = null;
			try {
				const res = await client.client.delete(`/api/devices/${this.device.objectId}/edge-attach`);
				this.edgeAttach = (res.data && res.data.results) || { isHalo: true, attached: false };
				await this.loadEdgeAttach();
			} catch (error) {
				console.error(error);
				const msg = error.response?.data?.errorMessage || error.message || 'Detach failed';
				this.edgeError = msg;
			} finally {
				this.edgeBusy = false;
			}
		}
    },
    watch: {
        device: {
            immediate: true,
            handler(newDevice) {
                this.deviceDetails = {...newDevice};
				this.loadEdgeAttach();
            }
        }
    },
    mounted() {
		this.getZones();
    },
}
</script>
<style lang="scss" scoped>
.controls {
    display: flex;
    align-items: center;
}
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .project-name {
        font: normal normal 20px Roboto;
    }
}
.edit-users-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 62px;
    padding: 15px;
    .v-input--selection-controls {
        margin: 0;
        padding: 0;
    }
}

.device-card {
    background: #25294A;
    border-radius: 20px;
    .v-input input {
        background: #141729;
        border-radius: 12px;
    }
    
    .personal-info {
        .edit-photo {
            display: flex;
            align-items: flex-end;
            img.avatar {
                border-radius: 50px;
                margin-right: 20px;
                max-width: 100px;
            }
        }        
        .name-wrp {
            display: flex;
        }
    }
}
.no-users {
    background: #25294A;
    border-radius: 20px;
    box-shadow: 0px 100px 80px rgba(2, 4, 12, 0.12), 0px 41.7776px 33.4221px rgba(2, 4, 12, 0.0862625), 0px 22.3363px 17.869px rgba(2, 4, 12, 0.0715329), 0px 12.5216px 10.0172px rgba(2, 4, 12, 0.06), 0px 6.6501px 5.32008px rgba(2, 4, 12, 0.0484671), 0px 2.76726px 2.21381px rgba(2, 4, 12, 0.0337375);
    margin: 56px auto;
    max-width: 460px;
    padding: 24px;
    text-align: center;
    width: 100%;
}
</style>